import 'tooltipster';

import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './tooltip.scss';

export default class Tooltip extends Component {
    static initSelector: string = '.js-tooltip';

    theme: string;
    tipDistance: number;
    contentClass: string;
    trigger: string;
    tipType: string;

    constructor(target: HTMLElement) {
        super(target);

        this.theme = this.element.attr('data-tooltipster-theme');
        this.tipDistance = 10;
        this.contentClass = 'tooltip__inner';
        this.trigger = this.element.attr('data-tooltipster-trigger') ? this.element.attr('data-tooltipster-trigger') : 'click';
        this.tipType = this.element.attr('data-type');

        this.init();
    }

    init(): void {
        if (this.tipType === 'apt') {
            const apartment: JQuery = this.element;
            const theme: string = this.element.attr('data-tooltipster-theme');
            const title: string = this.element.attr('data-tooltip-title');
            const text: string = this.element.attr('data-tooltip-text');
            const content: JQuery = $(`<div class="tooltip__inner"><div class="tooltip__title">${title}</div><div class="tooltip__content">${text}</div></div>`);

            apartment.tooltipster({
                animation: 'fade',
                animationDuration: 400,
                content,
                contentCloning: true,
                delay: 0,
                distance: -10,
                theme,
                trigger: 'custom',
                triggerClose: {
                    mouseleave: true,
                    originClick: true,
                    tap: true,
                },
                triggerOpen: {
                    mouseenter: true,
                    tap: true,
                },
            });
        } else {
            this.element.tooltipster({
                animation: 'fade',
                animationDuration: 400,
                contentCloning: true,
                delay: 0,
                distance: this.tipDistance,
                functionInit: this.functionInit,
                side: ['top', 'bottom', 'left', 'right'],
                theme: this.theme,
                trigger: 'custom',
                triggerClose: {
                    mouseleave: true,
                    originClick: true,
                    tap: true,
                },
                triggerOpen: {
                    mouseenter: true,
                    tap: true,
                },
            });
        }
    }

    // eslint-disable-next-line
    functionInit(instance, helper): void {
        const content: JQuery = $(helper.origin).find('.tooltip__inner').detach();

        instance.content(content);

        if ($(helper.origin).hasClass('is-open') && !Helpers.isMobileDevice) {
            instance.open();
        }
    }
}
